import { styled } from "@mui/material";
import { InfoContainer } from "./InfoContainer";

export const InfoBorderContainer = styled(InfoContainer)(() => ({
  border: "solid 0.5px #CACACA",
  minHeight: "100px",
}));
